import React, { useState, useEffect, useCallback } from "react";
import "../../Styles/yellowcalf.css/Collection_Report.css";
import { simplePostCall } from "../../api/ApiServices";
import ApiConfig from "../../api/ApiConfig";
import ScaleLoader from "react-spinners/ScaleLoader";
import { formatNumber } from "../../utils/formatNumber";

function Collection_Report() {
  const customer_currency = (localStorage.getItem("customer_currency") || "").replace(/"/g, "");
  const [reportData, setReportData] = useState([]);
  const [loading, setLoading] = useState(false);

  const [startDate, setStartDate] = useState("2025-11-27");
  const [endDate, setEndDate] = useState("2026-02-02");
  const [mode, setMode] = useState("");

  const [grades, setGrades] = useState([]);
  const [selectedGrade, setSelectedGrade] = useState("");

  const fetchInitialData = useCallback(async () => {
    setLoading(true);
    try {
      const payload = {
        customer_id: Number(localStorage.getItem("customer_id")) || 1005,
        api_key:
          localStorage.getItem("api_key") || "b9359f494e77b6589ce12dd62518c585",
        language: "en",
        user_id: localStorage.getItem("user_id") || 14857,
        start_date: startDate,
        end_date: endDate,
        transaction_mode: mode,
        class_id: selectedGrade,
      };

      const response = await simplePostCall(
        ApiConfig.collection1Report,
        JSON.stringify(payload),
      );

      if (response && response.result) {
        setReportData(response.searchModel || []);
      }
    } catch (error) {
      console.error("Error fetching report:", error);
    } finally {
      setLoading(false);
    }
  }, [startDate, endDate, mode, selectedGrade]);

  useEffect(() => {
    fetchInitialData();
  }, [fetchInitialData]);

  const fetchGrades = useCallback(async () => {
    try {
      const res = await simplePostCall(ApiConfig.classlist, JSON.stringify({
        customer_id: Number(localStorage.getItem("customer_id")),
        api_key: localStorage.getItem("api_key"),
      }));
      if (res?.classread) setGrades(res.classread);
    } catch (err) {
      console.error(err);
    }
  }, []);

  useEffect(() => {
    fetchGrades();
  }, [fetchGrades]);

  const handleClearFilters = () => {
    setStartDate("");
    setEndDate("");
    setMode('');
    setSelectedGrade('');
  };

  return (
    <div className="fee-container">
      <div className="special-header panel-white-all">
        <h4 className="page-title">Collection Report</h4>
      </div>

      <div className="yc-list-body">
        <div className="yc-list-filter">
          <select
            className="form-select"
            value={selectedGrade}
            onChange={(e) => setSelectedGrade(e.target.value)}
          >
            <option value="">All Grades</option>
            {grades.map((grade) => (
              <option key={grade.class_id} value={grade.class_id}>
                {grade.class_name}
              </option>
            ))}
          </select>

          <select
            className="form-select"
            value={mode}
            onChange={(e) => setMode(e.target.value)}
          >
            <option value="">All Modes</option>
            <option value="by cash">By Cash</option>
            <option value="cheque">Cheque</option>
            <option value="dd">DD</option>
            <option value="bank transfer">Bank Transfer</option>
            <option value="mpesa_manual">Mpesa</option>
            <option value="wallet">Wallet</option>
          </select>

          <input
            type="date"
            className="form-control"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
          />

          <input
            type="date"
            className="form-control"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
          />

          <button className="btn btn-primary" onClick={handleClearFilters}>
            Clear
          </button>
        </div>

        <div className="yc-list-thead-card">
          <div className="yc-list-grid yc-list-grid-5">
            <div className="yc-list-cell">Sr.No</div>
            <div className="yc-list-cell">Payment For</div>
            <div className="yc-list-cell">Class Name</div>
            <div className="yc-list-cell">Mode</div>
            <div className="yc-list-cell">Total Amount</div>
          </div>
        </div>

        {loading ? (
          <div className="d-flex justify-content-center align-items-center" style={{ height: "20vh" }}>
            <ScaleLoader color="#F4BB44" />
          </div>
        ) : reportData.length > 0 ? (
          <div className="yc-list-row-list">
            {reportData.map((item, index) => (
              <div key={index} className="yc-list-row-card">
                <div className="yc-list-grid yc-list-grid-5">
                  <div className="yc-list-cell">{index + 1}</div>
                  <div className="yc-list-cell">{item.transaction_payment_for?.toUpperCase()}</div>
                  <div className="yc-list-cell">{item.class_name?.replace("_", " ")}</div>
                  <div className="yc-list-cell">{item.transaction_mode?.replace("_", " ")}</div>
                  <div className="yc-list-cell yc-amount-positive">
                    {customer_currency} {formatNumber(item.sum)}
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="yc-empty-state">No records found.</div>
        )}
      </div>
    </div>
  );
}

export default Collection_Report;
